<template>
  <div class="about p-4">
    <b-container class="my-4">
      <h1>Om ARVID</h1>
      <hr>
      <b-alert :show="error !== ''" variant="danger">{{error}}</b-alert>
      <b-skeleton-img v-if="loading"></b-skeleton-img>
      <div v-else v-html="content"></div>
    </b-container>
  </div>
</template>

<script>
export default {
  data: () => ({
    content: null,
    loading: true,
    error: ''
  }),
  mounted() {
    this.getContent()
  },
  methods: {
    getContent() {
      let config = this.$store.getters.getConfig
      this.axios.get('/api/sections/about/', config).then((response) => {
        this.content = response.data.content
        
        this.loading = false
      }).catch(error => {
        console.error(error)
        this.error = error
        this.loading = false
      })
    },
  }
}
</script>
